import { rejected, resolved } from 'store/createAction';
import { FETCH_DCC, GET_CONTACT } from './types';

const initialState = {
  dcc: null,
  contact: null,
  loading: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case FETCH_DCC:
      return {
        ...state,
        loading: true,
      };
    case resolved(FETCH_DCC):
      console.log(payload);
      return {
        ...state,
        loading: false,
        dcc: payload,
      };
    case resolved(GET_CONTACT):
      return {
        ...state,
        contact: payload,
      };
    default:
      return state;
  }
};
